module.exports = "/packs/images/changing_places_logo~4bf03943e3bcafe340cdc7fe5b88b79d.png";